import { useQuery } from '@/models/api-store'
import { MetricCard } from './MetricCard'
import { observer } from 'mobx-react-lite'

export const TotalUsersCard = observer(() => {
  const totalUsers = useQuery((store) => store.queryGetTotalUsers())
  return <MetricCard title="Registered Users" metric={totalUsers.data?.getTotalUsers?.toString() || '0'} icon="group" />
})
